"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNovageSkincareAdvisor = exports.novageSkincareAdvisorContext = exports.defaultNovageSkincareAdvisorContextValue = exports.Provider = exports.NovageSkincareAdvisorProvider = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _useGetNovageSkincareConfiguration = require("../hooks/useGetNovageSkincareConfiguration");
var _useGetRevieveConfiguration = require("../hooks/useGetRevieveConfiguration");
var _useOnHrefClick = require("../hooks/useOnHrefClick");
var _useOnPDPHrefClick = require("../hooks/useOnPDPHrefClick");
var _logger = require("../logger");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve -- No important logic to test */

const localLogger = _logger.mainLogger.createChild('NovageSkincareAdvisorProvider');
const onError = error => localLogger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));
const defaultNovageSkincareAdvisorContextValue = exports.defaultNovageSkincareAdvisorContextValue = {
  initialOpenDone: false,
  novageSkincareConfiguration: undefined,
  openQueryParam: undefined,
  revieveConfiguration: undefined
};
const novageSkincareAdvisorContext = exports.novageSkincareAdvisorContext = /*#__PURE__*/(0, _react.createContext)(defaultNovageSkincareAdvisorContextValue);
const {
  Provider
} = novageSkincareAdvisorContext;
exports.Provider = Provider;
const NovageSkincareAdvisorProvider = ({
  children,
  translations
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const [initialOpenDone, setInitialOpenDone] = (0, _react.useState)(false);
  const [openQueryParam, setOpenQueryParam] = (0, _react.useState)();
  const open = (0, _react.useCallback)(param => () => {
    if (openQueryParam !== _constants.OPEN_QUERY_PARAM_ALWAYS) {
      (0, _utils.setOpenQueryParam)(param);
      setOpenQueryParam(_constants.OPEN_QUERY_PARAM_ONCE);
      setInitialOpenDone(true);
    }
  }, [openQueryParam]);
  (0, _useOnHrefClick.useOnHrefClick)({
    href: _constants.OPEN_SKIN_DIAGNOSIS_HREF_ATTRIBUTE,
    onClick: open(_constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM)
  });
  (0, _useOnHrefClick.useOnHrefClick)({
    href: _constants.OPEN_FOUNDATION_FINDER_HREF_ATTRIBUTE,
    onClick: open(_constants.OPEN_FOUNDATION_FINDER_QUERY_PARAM)
  });
  (0, _useOnHrefClick.useOnHrefClick)({
    href: _constants.OPEN_VIRTUAL_TRY_ON_HREF_ATTRIBUTE,
    onClick: open(_constants.OPEN_VIRTUAL_TRY_ON_QUERY_PARAM)
  });
  (0, _useOnPDPHrefClick.useOnPDPHrefClick)({
    onClick: open(_constants.OPEN_VIRTUAL_TRY_ON_PDP_QUERY_PARAM)
  });
  (0, _react.useEffect)(() => {
    const initialOpenQueryParam = (0, _utils.getValidOpenQueryParam)() ?? (0, _utils.getValidOpenQueryParam)(_constants.OPEN_FOUNDATION_FINDER_QUERY_PARAM) ?? (0, _utils.getValidOpenQueryParam)(_constants.OPEN_VIRTUAL_TRY_ON_QUERY_PARAM) ?? (0, _utils.getValidOpenQueryParam)(_constants.OPEN_VIRTUAL_TRY_ON_PDP_QUERY_PARAM);
    if (initialOpenQueryParam) {
      setOpenQueryParam(initialOpenQueryParam);
      setInitialOpenDone(true);
    }
  }, []);
  const novageSkincareConfiguration = (0, _useGetNovageSkincareConfiguration.useGetNovageSkincareConfiguration)();
  const revieveConfiguration = (0, _useGetRevieveConfiguration.useGetRevieveConfiguration)();
  const value = (0, _react.useMemo)(() => ({
    initialOpenDone,
    novageSkincareConfiguration,
    openQueryParam,
    revieveConfiguration
  }), [initialOpenDone, novageSkincareConfiguration, openQueryParam, revieveConfiguration]);
  const shouldFetchTranslations = (0, _react.useMemo)(() => initialOpenDone || novageSkincareConfiguration?.recommendationPageEnabled, [initialOpenDone, novageSkincareConfiguration?.recommendationPageEnabled]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    language: language,
    defaultTranslationsWithNamespaces: {
      [_constants.translationsNamespace]: _constants.defaultTranslations
    },
    translationsWithNamespaces: translations ? {
      [_constants.translationsNamespace]: translations
    } : undefined,
    clientFetchConfiguration: shouldFetchTranslations ? {
      tenant,
      baseUrl: staticApiUrl,
      onError
    } : undefined,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _constants.translationsNamespace,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
      })
    })
  });
};
exports.NovageSkincareAdvisorProvider = NovageSkincareAdvisorProvider;
const useNovageSkincareAdvisor = () => (0, _react.useContext)(novageSkincareAdvisorContext);
exports.useNovageSkincareAdvisor = useNovageSkincareAdvisor;
